import { render } from "./BlankPageSalesShmone.vue?vue&type=template&id=1128d212&scoped=true"
import script from "./BlankPageSalesShmone.vue?vue&type=script&lang=js"
export * from "./BlankPageSalesShmone.vue?vue&type=script&lang=js"

import "./BlankPageSalesShmone.vue?vue&type=style&index=0&id=1128d212&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1128d212"]])

export default __exports__